import { styled } from '@clickcease/cc-client-components-lib'

export const HelpCenterModalStyled = styled('div', {})

export const CardSectionWrapper = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(6, 1fr)',
  gridTemplateRows: 'repeat(2, 195px)',
  gap: '$10',
  padding: '$6',

  '> :nth-child(1)': { gridArea: '1 / 1 / 2 / 3' },
  '> :nth-child(2)': { gridArea: '1 / 3 / 2 / 5' },
  '> :nth-child(3)': { gridArea: '1 / 5 / 2 / 7' },
  '> :nth-child(4)': { gridArea: '2 / 2 / 3 / 4' },
  '> :nth-child(5)': { gridArea: '2 / 4 / 3 / 6' },
})

export const Cards = styled('div', {
  textAlign: 'center',
  boxShadow: '$dropDown',
  borderRadius: '$medium',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',

  ['&:hover']: {
    background: '$tableSelected',
    border: '$primaryColor 1px solid',
  },
})

export const CardImage = styled('div', {})

export const CardSubtitle = styled('p', {
  fontSize: '$sm',
  fontWeight: '$l',
  width: '200px',
})

export const CardTitle = styled('div', {
  fontSize: '$lg',
  fontWeight: '$sb',
})
